import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";


import PrivateRoute from './components/router/PrivateRoute.jsx';
import PrivateApoderadoRoute from './components/router/PrivateApoderadoRoute.jsx';
import PublicAuthRoute from './components/router/PublicAuthRoute.jsx'; 
import { AuthProvider } from './context/AuthContext';


// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes"; 
import { SidebarProvider } from "./context/Sidebar"; 
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator"; 
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, ForgotPasswordPage , ResetPasswordCodeVerificationPage, ResetPasswordNewPasswordPage} from "./pages/auth";
import { EcommercePage, UserProfilePage, UserListPage, GiraViewPage, MiGiraViewPage, DetallePasajeroPage, MyAccountPage, 
    GirasListPage, GastosListPage, GastosRegistroPage, GastosListadoCompletePage, FondosPresupuestoPage, GastosReportesPage, GastosConfiguracionPage, 
    GastoDetalleViewPage, GastoValidacionPage, MisGirasListPage, MiPagoWebpayPage, MiPagoKhipuPage, MiPagoGetnetPage} from "./pages/main";

const router = createBrowserRouter([

    // PUBLIC PAGES
    { path: "/", element: (<PublicAuthRoute><LoginPage /></PublicAuthRoute>)  },  
    { path: "/recuperar-password", element: (<PublicAuthRoute><ForgotPasswordPage /></PublicAuthRoute>)  },
    { path: "recuperar-password/verificar-codigo/:uuid", element: (<PublicAuthRoute><ResetPasswordCodeVerificationPage /></PublicAuthRoute>)  },
    { path: "recuperar-password/modificar/:uuid", element: (<PublicAuthRoute><ResetPasswordNewPasswordPage /></PublicAuthRoute>)  },
    { path: "/login", element: (<PublicAuthRoute><LoginPage /></PublicAuthRoute>)   },



    // Admin Pages
    { path: "/dashboard", element: (
        <PrivateRoute>
          <EcommercePage />
        </PrivateRoute>
      ),  },
    //Giras de Estudios
    { path: "/listado-giras",  element: (
        <PrivateRoute>
          <GirasListPage />
        </PrivateRoute>
      )},
    { path: "/ver-gira", element: (
        <PrivateRoute>
          <GiraViewPage />
        </PrivateRoute>
      ) },
    { path: "/detalle-pasajero", element: (
        <PrivateRoute>
          <DetallePasajeroPage />
        </PrivateRoute>
      ) },

      { path: "/user-list", element: <PrivateRoute><UserListPage /> </PrivateRoute>},
      { path: "/user-profile", element: <PrivateRoute><UserProfilePage /></PrivateRoute> },

     //Ingreso de Gastos
     { path: "/listado-gastos", element: (
        <PrivateRoute>
          <GastosListPage />
        </PrivateRoute>
      ) },
     { path: "/gastos", element: (
        <PrivateRoute>
          <GastosListPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/listado-completo", element: (
        <PrivateRoute>
          <GastosListadoCompletePage />
        </PrivateRoute>
      ) },
     { path: "/gastos/registro", element: (
        <PrivateRoute>
          <GastosRegistroPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/fondos", element: (
        <PrivateRoute>
          <FondosPresupuestoPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/reportes", element: (
        <PrivateRoute>
          <GastosReportesPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/configuracion", element: (
        <PrivateRoute>
          <GastosConfiguracionPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/ver/:id", element: (
        <PrivateRoute>
          <GastoDetalleViewPage />
        </PrivateRoute>
      ) },
     { path: "/gastos/validar/:id", element: (
        <PrivateRoute>
          <GastoValidacionPage />
        </PrivateRoute>
      ) },

 

    // User Pages
    { path: "/home", element: (<PrivateApoderadoRoute><MisGirasListPage /></PrivateApoderadoRoute> ) },
    { path: "/mis-giras", element: (<PrivateApoderadoRoute><MisGirasListPage /></PrivateApoderadoRoute> ) 
      
     },
    { path: "/ver-mi-gira", element:  (<PrivateApoderadoRoute><MiGiraViewPage /></PrivateApoderadoRoute> )  },
    { path: "/webpay-plus/commit", element:  (<PrivateApoderadoRoute><MiPagoWebpayPage /></PrivateApoderadoRoute> )  },
    {path: "/khipu/commit", element:  (<PrivateApoderadoRoute><MiPagoKhipuPage /></PrivateApoderadoRoute> )  },
    {path: "/khipu/cancel", element:  (<PrivateApoderadoRoute><MiPagoKhipuPage /></PrivateApoderadoRoute> )  },

    {path: "/getnet/commit", element:  (<PrivateApoderadoRoute><MiPagoGetnetPage /></PrivateApoderadoRoute> )  },
    {path: "/getnet/cancel", element:  (<PrivateApoderadoRoute><MiPagoGetnetPage /></PrivateApoderadoRoute> )  },

    { path: "/logout", element:  <DetallePasajeroPage /> },
    //{ path: "/crm", element: <CRMPage /> },
    
    //{ path: "/register", element: <RegisterPage /> },
    
    //

  
    { path: "/mi-cuenta", element: <MyAccountPage /> },
    
   
    //{ path: "/invoice-list", element: <InvoiceListPage /> },
    //{ path: "/invoice-details", element: <InvoiceDetailsPage /> },
    //{ path: "/order-list", element: <OrderListPage /> },
    //{ path: "/message", element: <MessagePage /> },
    //{ path: "/notification", element: <NotificationPage /> },
    //{ path: "/blank-page", element: <BlankPage /> },
    //{ path: "/settings", element: <SettingsPage /> },

    // UI PAGES
    //{ path: "/avatars", element: <AvatarPage /> },                               
    //{ path: "/alerts", element: <AlertPage /> },                               
    //{ path: "/buttons", element: <ButtonPage /> },                               
    //{ path: "/charts", element: <ChartPage /> },                               
    //{ path: "/tables", element: <TablePage /> },                               
    //{ path: "/fields", element: <FieldPage /> },                               
    //{ path: "/headings", element: <HeadingPage /> },                               
    //{ path: "/colors", element: <ColorPage /> },   

    // OTHER PAGES
                                 
    //{ path: "/documentation", element: <DocumentationPage /> },                               
    //{ path: "/changelog", element: <ChangeLogPage /> },                               
    //{ path: "/error", element: <ErrorPage /> },  
]);


createRoot(document.getElementById("root")).render(
    <ThemeProvider>
        <LoaderProvider>
        <TranslatorProvider>
                <SidebarProvider>
                    <AuthProvider>
                            <RouterProvider router={router} />
                    </AuthProvider>   
                </SidebarProvider>
          </TranslatorProvider>
        </LoaderProvider>
    </ThemeProvider>
);